import React from 'react';
import './App.css';
// import NameBlock from './NameBlock';
// import babyNameData from './babyNameData.json';
import Search from './Search'

function App() {
  return (
    <div className='App'>
      <Search />
    </div>
  );
}

export default App;
